<template lang="pug">
    .container.content(ref="container")
        .validation(v-if="edit")
            validation-provider(
                ref="image"
                :vid="vid"
                :name="name"
                :rules="rules"
                v-slot="{ errors }"
            )
                .upload(v-if="! image")
                    vue-dropzone(
                        ref="newImage"
                        id="new-image"
                        :class="{ 'is-danger': errors && errors.length }"
                        :options="dropzoneOptions"
                        :use-font-awesome="true"
                        :auto-process-queue="true"
                        :upload-multiple="false"
                        :useCustomSlot="true"
                        @vdropzone-sending="newImageSending"
                        @vdropzone-sending-multiple="newImageSending"
                        @vdropzone-success="newImageUploaded"
                        @vdropzone-error="newImageUploadFailed"
                    )
                        .dropzone-custom-content
                            i.fas.fa-cloud-upload-alt
                            h4.is-size-4.dropzone-custom-title(v-html="labels.title")
                            .subtitle(v-html="labels.sub_title")
                input#image-validation(type="hidden" name="image" v-model="src")
                p.help.is-danger.has-text-left(v-if="errors && errors.length") {{ errors[0] }}
                p.help.has-text-grey.has-text-left(v-else-if="! image") Pflicht
        .image(v-if="image")
            figure(:style="{ width: `${width}px`, height: `${height}px` }")
                button.delete(v-if="edit" @click="$emit('change', section.id, content.id, content.images[0], 'delete')")
                img(
                    v-lazy="image"
                    :title="title || subTitle"
                    :style="{ width: `${width}px`, height: `${height}px` }"
                    rel="noopener"
                )
            p(v-if="title") {{ title }}
            small(v-if="subTitle") {{ subTitle }}
</template>

<script>

import _ from 'lodash'
import vueDropzone from 'vue2-dropzone'
import { ValidationProvider } from 'vee-validate'

import store from '@/store'

export default {
    name: 'ImageSection',
    data() {
        return {
            src: '',
            maxW: undefined,
            // aspectRatio: undefined,
            // w: undefined,
            // h: undefined,
            dropzoneOptions: {
                url: store.state.setup.uploadEndpoint,
                // url: 'http://127.0.0.1/store/images',
                // addRemoveLinks: true,
                acceptedFiles: '.jpg,.jpeg,.png',
                maxFiles: 1,
                thumbnailWidth: 100,
                thumbnailHeight: 100,
                maxFilesize: 2,
                previewTemplate: this.previewTemplate(),
                timeout: 6 * 60 * 1000, // 6 minutes
            },
        }
    },
    props: {
        vid: {
            type: String,
        },
        name: {
            type: String,
            default: '',
        },
        rules: {
            type: [Object, String],
            default: "",
        },
        edit: {
            type: Boolean,
            default: false,
        },
        section: {
            type: Object,
            required: true,
        },
    },
    components: {
        vueDropzone,
        ValidationProvider,
    },
    watch: {
        image(fresh, old) {
            if (fresh) {
                this.src = fresh.src
            } else {
                this.src = ''
                if (old && this.$refs.image.mode === 'aggressive' || this.$refs.image.mode === 'lazy') {
                    setTimeout(this.$refs.image.validate, 0)
                }
            }
        }
    },
    computed: {
        content() {
            return _.get(this.section, 'contents.0')
            // return this.section.contents.find(content => content.key === 'image')
        },
        title() {
            return _.get(this.content, 'title')
        },
        subTitle() {
            return _.get(this.content, 'sub_title')
        },
        labels() {
            let labels = {
                title: _.get(this.section, 'labels.title') || 'Bild hier ablegen',
                sub_title: _.get(this.section, 'labels.sub_title') || 'oder <span class="href">hier klicken</span>',
            }

            return labels
        },
        width() {
            if (this.image.width && this.maxW) return _.min([this.image.width, this.maxW])
            else return undefined
        },
        height() {
            if (this.width && this.image.aspectRatio) return this.width / this.image.aspectRatio
            else return undefined
        },
        image() {
            const image = _.get(this.content, 'images.0')
            if (! image) return false

            const storageRoute = _.trim(`${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_PUBLIC_STORAGE_ROUTE}`, '/')

            let fit = _.get(image, 'pivot.fit') || 'fit=crop&crop=focalpoint&x=.5&y=.5&z=1'
            const parameters = {
                ... _.get(fit.match(/x=(?<fx>[0-1]?\.?[0-9]*)/), 'groups'),
                ... _.get(fit.match(/y=(?<fy>[0-1]?\.?[0-9]*)/), 'groups'),
                ... _.get(fit.match(/z=(?<fz>[1-9]+\.?[0-9]*)/), 'groups'),
                ... _.get(fit.match(/w=(?<w>[0-9]+\.?[0-9]*)/), 'groups'),
                ... _.get(fit.match(/h=(?<h>[0-9]+\.?[0-9]*)/), 'groups'),
            }
            let { w, h, fx, fy, fz } = parameters

            let width, height, aspectRatio

            width = image.width / fz
            height = image.height / fz
            aspectRatio = width / height

            height = Math.min(window.innerWidth >= 1088 ? 780 : 400, height)
            width = height * aspectRatio

            if (w && h) {
                aspectRatio = w / h

                height = Math.min(window.innerWidth >= 1088 ? 780 : 400, image.height / fz)
                width = height * aspectRatio

                fit = fit.replace(/w=([0-9]+\.?[0-9]*)/, `w=${width}`).replace(/h=([0-9]+\.?[0-9]*)/, `h=${height}`)
            } else if (! w && ! h) {
                fit += `&h=${height}`
            }

            let table = 'images'
            if (image.upload) table = 'uploads'

            return {
                src: `${storageRoute}/${table}/${image.id}/${image.name}?${fit}`,
                error: `${storageRoute}/${table}/${image.id}/${image.name}?${fit}&preview=greyscale`,
                loading: `${storageRoute}/${table}/${image.id}/${image.name}?${fit}&preview=blur`,
                width,
                height,
                aspectRatio,
            }
        },
        // src() {
        //     return _.get(this.image, 'src', '') || ''
        // }
    },
    methods: {
        validate() {
            console.log('validate');
        },
        previewTemplate() {
            return `
                <div class="dz-preview dz-file-preview">
                    <div class="dz-filename">
                        <span data-dz-name></span>
                    </div>
                    <div class="dz-size" data-dz-size></div>
                    <div class="dz-thumbnail">
                        <img data-dz-thumbnail />
                    </div>
                    <div class="dz-progress">
                        <span class="dz-upload" data-dz-uploadprogress></span>
                    </div>
                    <div class="dz-success-mark">
                        <i class="fas fa-check"></i>
                    </div>
                    <div class="dz-error-mark">
                        <i class="fas fa-times"></i>
                    </div>
                    <div class="dz-error-message">
                        <span data-dz-errormessage></span>
                    </div>
                </div>
            `;
        },
        newImageSending(file, xhr, formData) {
            formData.append('context[type]', 'content-image')
            formData.append('token', localStorage.getItem('member-token'))
            xhr.ontimeout = e => console.log('Server Timeout')
        },
        newImageUploaded(file, response) {
            this.$refs.newImage.removeFile(file)

            let image = response
            image.upload = true

            delete image.hash

            const storageRoute = _.trim(`${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_PUBLIC_STORAGE_ROUTE}`, '/')
            const table = 'uploads'

            let img = new Image()
            img.src = `${storageRoute}/${table}/${image.id}/${image.name}` // ?token=${localStorage.getItem('member-token')}
            img.onload = () => {
                image.width = img.width
                image.height = img.height

                this.$emit('change', this.section.id, undefined, image, 'add')
            }
        },
        newImageUploadFailed(file) {
            setTimeout(() => {
                this.$refs.newImage.removeFile(file)
            }, 2000)
        }
    },
    mounted() {
        const calculateMaxWidth = () => {
            if (this.$refs.container) {
                const style = getComputedStyle(this.$refs.container)
                this.maxW = this.$refs.container.clientWidth
                this.maxW -= parseFloat(style.paddingLeft) + parseFloat(style.paddingRight)
            }
        }

        window.addEventListener('resize', _.debounce(calculateMaxWidth, 100))
        calculateMaxWidth()
    }
}
</script>

<style lang="sass" scoped>

    @import "~bulma/sass/utilities/mixins";
    @import '~@/assets/sass/variables';
    .landingpage
        .section.image
            .container.content
                .image
                    width: 100%
                    figure
                        width: 100%!important
                    img
                        width: 100%!important
    .content
        display: flex
        flex-direction: column
        align-items: center
        .image
            figure
                display: block
                margin-bottom: 2px
                position: relative
                .delete
                    position: absolute
                    top: 4px
                    right: 4px
                    z-index: 4
                img
                    width: auto
                    height: initial
                    border-radius: 4px
                    display: inline-block
                    &[lazy=loading]
                        box-shadow: none
                    &[lazy=loaded]
                        // max-height: 500px
                        // height: initial !important
                        // width: initial !important
                        box-shadow: $box-shadow-3
            p
                margin-bottom: 0
                font-size: .8rem
            small
                font-size: .65rem
                display: block
        .upload
            width: 100%
            & > .column
                padding-top: 0
                padding-bottom: 0
        .validation
            width: 100%
</style>
